import { Component, OnInit, inject, viewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { IClaim } from "../core/models/IClaim";
import { DataAccessService } from "../core/services/data-access.service";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { DatePipe } from "@angular/common";

@Component({
    selector: "history_dialog",
    templateUrl: "history_dialog.html",
    styleUrls: ["./claims.component.scss"],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions, DatePipe]
})
export class ClaimHistoryDialog implements OnInit {
  dialogRef = inject<MatDialogRef<ClaimHistoryDialog>>(MatDialogRef);
  data = inject<object>(MAT_DIALOG_DATA);
  private dataAccess = inject(DataAccessService);

  readonly sort1 = viewChild("table1", { read: MatSort });

  displayedColumns: string[] = [
    "change_date",
    "changed_by",
    "claim_status",
    "customers_comments",
    "suppliers_comments",
    "customer_attachments",
    "supplier_attachments",
    "claim_reason_codes",
  ];

  dataSource: MatTableDataSource<IClaim> = new MatTableDataSource<IClaim>();

  id: number;
  claim_no: string;

  constructor() {
    const data = this.data;

    this.id = (data as any).lineId;
    this.claim_no = (data as any).claimNo;
  }

  ngOnInit() {
    this.dataAccess
      .getJSONPost("get_claim_history", [], [{ k: "p_id", v: this.id }])
      .then((data) => {
        this.dataSource.sort = this.sort1();
        this.dataSource.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId]
            ? typeof data[sortHeaderId] === "string"
              ? data[sortHeaderId].toString().toLocaleLowerCase()
              : data[sortHeaderId]
            : null;
        this.dataSource.data = Array.isArray(data) ? data : [];
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
